"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProfileScene = void 0;
const react_1 = __importStar(require("react"));
require("./index.scss");
const react_helmet_1 = __importDefault(require("react-helmet"));
const tabs_constants_1 = require("@Const/tabs-constants");
const ProfileSceneUserTab_1 = require("@Scenes/ProfileScene/ProfileSceneUserTab");
const ProfileSceneRightsholderTab_1 = require("@Scenes/ProfileScene/ProfileSceneRightsholderTab");
const contexts_1 = require("@App/contexts");
const TabsWrapperComponent_1 = __importDefault(require("@Components/TabsWrapperComponent"));
const analytics_utils_1 = require("@App/common/utils/analytics-utils");
const ProfileSceneSongwriterTab_1 = __importDefault(require("@Scenes/ProfileScene/ProfileSceneSongwriterTab"));
const react_sdk_1 = require("@openfeature/react-sdk");
const ProfileScene = () => {
    const { value: showSongwriterTab } = (0, react_sdk_1.useFlag)('member-songwriter-signup-rework', false);
    const { userStore } = (0, react_1.useContext)(contexts_1.StoresContext);
    const tabs = [
        {
            tabName: tabs_constants_1.USER_PROFILE_TABS.user,
            tabComponent: react_1.default.createElement(ProfileSceneUserTab_1.ProfileSceneUserTab, { key: tabs_constants_1.USER_PROFILE_TABS.user }),
        },
        {
            tabName: tabs_constants_1.USER_PROFILE_TABS.rightsholders,
            tabComponent: react_1.default.createElement(ProfileSceneRightsholderTab_1.ProfileSceneRightsholderTab, { key: tabs_constants_1.USER_PROFILE_TABS.rightsholders }),
        },
        ...(showSongwriterTab
            ? [
                {
                    tabName: tabs_constants_1.USER_PROFILE_TABS.songwriters,
                    tabComponent: react_1.default.createElement(ProfileSceneSongwriterTab_1.default, { key: tabs_constants_1.USER_PROFILE_TABS.songwriters }),
                },
            ]
            : []),
    ];
    (0, react_1.useEffect)(() => {
        (0, analytics_utils_1.analyticsSendPage)('profile');
    }, []);
    return userStore.userInfo ? (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(react_helmet_1.default, { title: 'Profile' }),
        react_1.default.createElement("main", { className: 'profile-scene' },
            react_1.default.createElement("div", { className: 'global-container' },
                react_1.default.createElement("div", { className: "head" },
                    react_1.default.createElement("h2", null, "Profile")),
                react_1.default.createElement(TabsWrapperComponent_1.default, { tabs: tabs, defaultTab: tabs[0] }))))) : null;
};
exports.ProfileScene = ProfileScene;
